// RAMISI cart drawer recommendations v2 (Serenti-style).
// Cards are server-rendered by snippets/cart-drawer-recommendations.liquid;
// this module only handles the arrow navigation and the ADD buttons.
// Add flow mirrors product-form.js: POST /cart/add.js with a `sections`
// param, then dispatch CartAddEvent so every cart-items-component morphs.
// Delegated listeners on document so they survive section morphs.
import { CartAddEvent } from '@theme/events';

function scrollStep(list) {
  const card = list.querySelector('.rms-recos__card');
  return card ? card.getBoundingClientRect().width + 8 : 240;
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const nav = event.target.closest('[data-rms-recos-nav]');
  if (nav instanceof HTMLElement) {
    const list = nav.closest('.rms-recos')?.querySelector('.rms-recos__list');
    if (!list) return;
    const step = scrollStep(list);
    list.scrollBy({ left: nav.dataset.rmsRecosNav === 'next' ? step : -step, behavior: 'smooth' });
    return;
  }

  const button = event.target.closest('[data-rms-add]');
  if (button instanceof HTMLButtonElement) addVariant(button);
});

function readVariants(card) {
  const el = card ? card.querySelector('[data-rms-variants]') : null;
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (_) {
    return null;
  }
}

// colour change -> rebuild the size dropdown with sizes available in that colour
document.addEventListener('change', (event) => {
  const sel = event.target;
  if (!(sel instanceof HTMLSelectElement) || !sel.hasAttribute('data-rms-color')) return;
  const card = sel.closest('.rms-recos__card');
  const sizeSel = card ? card.querySelector('[data-rms-size]') : null;
  const variants = readVariants(card);
  if (!sizeSel || !variants) return;
  const previous = sizeSel.value;
  const sizes = [...new Set(variants.filter((v) => v.c === sel.value).map((v) => v.s))];
  sizeSel.textContent = '';
  for (const s of sizes) {
    const opt = document.createElement('option');
    opt.value = s;
    opt.textContent = s;
    sizeSel.appendChild(opt);
  }
  if (sizes.includes(previous)) sizeSel.value = previous;
});

function resolveVariantId(card, button) {
  const colorSel = card ? card.querySelector('[data-rms-color]') : null;
  const sizeSel = card ? card.querySelector('[data-rms-size]') : null;
  if (colorSel instanceof HTMLSelectElement && sizeSel instanceof HTMLSelectElement) {
    const variants = readVariants(card) || [];
    const match = variants.find((v) => v.c === colorSel.value && v.s === sizeSel.value);
    return match ? match.id : null;
  }
  const select = card ? card.querySelector('.rms-recos__select') : null;
  return (select instanceof HTMLSelectElement && select.value) || button.dataset.variantId;
}

async function addVariant(button) {
  if (button.disabled) return;
  const card = button.closest('.rms-recos__card');
  const variantId = resolveVariantId(card, button);
  if (!variantId) {
    const original = button.textContent;
    button.textContent = 'Indisponible';
    setTimeout(() => { button.textContent = original; }, 1600);
    return;
  }

  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Ajout…';

  try {
    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
      .filter(Boolean);

    const body = new FormData();
    body.append('id', String(variantId));
    body.append('quantity', '1');
    if (sectionIds.length) body.append('sections', sectionIds.join(','));

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body,
      headers: { Accept: 'application/json' },
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'add_failed');

    let itemCount;
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      itemCount = cart.item_count;
    } catch (_) {
      // the section morph refreshes the bubble anyway
    }

    button.textContent = 'Ajouté';
    document.dispatchEvent(
      new CartAddEvent({}, String(variantId), {
        source: 'rms-cart-recos',
        itemCount,
        variantId: String(variantId),
        sections: data.sections || undefined,
      })
    );
  } catch (_) {
    button.disabled = false;
    button.textContent = 'Réessayer';
    setTimeout(() => {
      button.textContent = label;
    }, 1600);
  }
}

